import Vue from "vue";
import VueGtag from "vue-gtag";
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import store from '../store';
import axios from "axios";
import router from '../router';

const track = {
    load(){
        if(store.getters['customer/pixel_google_analytics'] !== null && store.getters['customer/pixel_google_analytics'].toString().length > 1){
            Vue.use(VueGtag, {
                config: { id: store.getters['customer/pixel_google_analytics'] },
                params: {
                    send_page_view: true
                }
            });
        }
        if(store.getters['customer/pixel_facebook_analytics'] !== null && store.getters['customer/pixel_facebook_analytics'].toString().length > 1){
            Vue.use(VueFacebookPixel)
            Vue.analytics.fbq.init(store.getters['customer/pixel_facebook_analytics'], {})
        }
    },
    trackView(self, title, path) {
        if(self.$gtag !== undefined && store.getters['customer/pixel_google_analytics'] !== null && store.getters['customer/pixel_google_analytics'].toString().length > 1) {
            self.$gtag.query('event', 'page_view', {
                page_title: title,
                page_path: path
            });
        }
        if(Vue.analytics !== undefined && store.getters['customer/pixel_facebook_analytics'] !== null && store.getters['customer/pixel_facebook_analytics'].toString().length > 1){
            Vue.analytics.fbq.event('ViewContent', {
                content_name: title
            })
        }
    },
    trackEventAddCart(self, instance, product) {
        if(self.$gtag !== undefined && store.getters['customer/pixel_google_analytics'] !== null && store.getters['customer/pixel_google_analytics'].toString().length > 1) {
            self.$gtag.event('add_to_cart', {
                currency: instance.currency,
                items: [{
                    id: product.product_id,
                    name: product.label,
                    category: product.category,
                    price: product.price,
                    quantity: product.count
                }],
                value: product.total
            })
        }
        if(Vue.analytics !== undefined && store.getters['customer/pixel_facebook_analytics'] !== null && store.getters['customer/pixel_facebook_analytics'].toString().length > 1){
            Vue.analytics.fbq.event('AddToCart', {
                content_ids: product.product_id, 
                content_name: product.label,
                content_type: product.category,
                currency: instance.currency, 
                value: (product.price*product.count)
            })
        }
    },
    trackEventBeginCheckout(self, instance, purchase, shopping, productsCart) {
        try {
            let items = [];
            let productIds = [];

            for (let i = 0; i <productsCart.length; i++){
                let v = productsCart[i];
                productIds.push(v.product_id)
                items.push({item_id: v.product_id, item_name: v.label, currency: instance.currency, quantity: v.count, price: v.subtotal})
            }

            if(self.$gtag !== undefined && store.getters['customer/pixel_google_analytics'] !== null && store.getters['customer/pixel_google_analytics'].toString().length > 1) {
                self.$gtag.event('begin_checkout', {
                    currency: instance.currency,
                    value: shopping.total,
                    items: items
                })
            }
            if(Vue.analytics !== undefined && store.getters['customer/pixel_facebook_analytics'] !== null && store.getters['customer/pixel_facebook_analytics'].toString().length > 1){
                Vue.analytics.fbq.event('InitiateCheckout', {
                    content_ids: productIds,  
                    currency:instance.currency, 
                    num_items: shopping.purchase_product.length, 
                    value: shopping.total
                })
            }
        } catch (error) {
            (error)
        }
    },
    trackEventPurchase(self, instance, purchase) {
    try {
        let items = [];
        let productIds = [];
        for (let i = 0; i <purchase.products.length; i++){
            let v = purchase.products[i];
            productIds.push(v.product_id)
            items.push({item_id: v.id, item_name: v.label, currency: instance.currency, quantity: v.count, price: v.subtotal})
        }

        if(self.$gtag !== undefined && store.getters['customer/pixel_google_analytics'] !== null && store.getters['customer/pixel_google_analytics'].toString().length > 1) {

            self.$gtag.event('purchase', {
                currency: instance.currency,
                transaction_id: purchase.bck_purchase_id,
                value: purchase.total,
                items: items
            })
        }

        if(Vue.analytics !== undefined && store.getters['customer/pixel_facebook_analytics'] !== null && store.getters['customer/pixel_facebook_analytics'].toString().length > 1){
            Vue.analytics.fbq.event('Purchase', {
                content_ids: productIds,  
                currency:instance.currency, 
                num_items: productIds.length, 
                value: purchase.total
            })
        }
    } catch (error) {
        (error)
    }
    },
    trackEventCluvi(data, event){
        if( store.getters['profile/session_id'].length === 0){
            let self = this;
            setTimeout(function(){self.trackEventCluvi(data, event)}, 1000);
            return;
        }
        let data_track = {
          event: event,
          view_vue: router.app._route.name
        }
        
        data_track.home_height = data.home_height;
        data_track.device_height = data.device_height;
        data_track.product_supplier_ids = data.product_supplier_ids;

        data_track.table_code = store.getters['ontable/tableId']
        data_track.front_lang = store.getters['shared/lang']
        data_track.session_id = store.getters['profile/session_id']
        data_track.service = store.getters['order/service']
        data_track.customer_id = store.getters['customer/instance_id']
        data_track.supplier_id = store.getters['customer/supplier_id']
        data_track.profile_id = store.getters['profile/profile_id']
        data_track.acquisition_id = store.getters['shared/acquisition_id']
        if(data.product_supplier_id !== undefined){
            data_track.product_supplier_id = data.product_supplier_id 
        }
        if(data.product !== undefined){
            data_track = this.setDataFromProduct(data_track, data)
        }
        if(data.content_popup !== undefined){
            data_track.content_popup_id = data.content_popup.id
            data_track.image_format = this.getImageFormat(data.content_popup.image)
        }
        if(data.content_home !== undefined){
            data_track.content_home_id = data.content_home.id
        }
        if(data.content_home !== undefined && data.content_home.layout_type === 'banner'){
            data_track.image_format = this.getImageFormat(data.content_home.image)
        }
        if(data.purchase !== undefined){
            data_track.purchase_id = data.purchase.id
        }
        if(data.purchase_id !== undefined){
            data_track.purchase_id = data.purchase_id
        }
        if(data.products_cross !== undefined){
            data_track.products_cross_id = data.products_cross.id
        }
        if(data.maincategory_id !== undefined){
            data_track.maincategory_id = data.maincategory_id
        }
        if(data.subcategory_id !== undefined){
            data_track.subcategory_id = data.subcategory_id
        }
        if(data_track.event === 'searchTerms'){
            data_track.search_term = data.search_term
        }
        if(data.front_time_step !== undefined){
            data_track.front_time_step = data.front_time_step
        }
        if(data.search_term !== undefined){
            data_track.search_term = data.search_term
        }
        if(data.tipe_subcategory !== undefined){
            data_track.tipe_subcategory = data.tipe_subcategory
        }
        if(data.position && data.position > 0){
            data_track.position_relative = data.position;
            data_track.position_absolute = data.position;
        }
        
        axios({
            method: "post",
            url: `${process.env.VUE_APP_API_CLUVIMKT}/api/trackings.json`,
            data: data_track
        })
        if(window.dataLayer !== undefined){
            this.sendDataToGTM(data_track);
        }
    },
    sendDataToGTM(data_track){
        let event = data_track.event.replace(/ /g, "_");
        if(event === 'add_product') event = 'add_to_cart'
        if(event === 'view_product') event = 'view_item'
        if(event === 'view_cart_delivery') event = 'view_cart'
        if(event === 'view_precheckout') event = 'begin_checkout'
        if(event === 'view_order') event = 'purchase'
        
        
        
        //console.log(event);
        //console.log(data_track);
    },
    getImageFormat(image){
        try {
            const url = new URL(image.thumb);
            // Limpiar los parámetros de búsqueda
            url.search = '';
            return url.toString().split('.').pop();
        } catch (error) {
            return 'error'
        }
    },
    setDataFromProduct(data_track, data)
    {
        data_track.product_supplier_id = data.product.id
        data_track.product_id = data.product.product_id
        data_track.subcategory_id = data.product.supplier_category_id
        data_track.type_card = data.product.type_card_track
        data_track.is_alcoholic = data.product.is_alcoholic
        data_track.is_new = data.product.is_new
        data_track.has_discount = data.product.promo
        data_track.discount_percentage = data.product.promo_porcent
        data_track.has_image = (data.product.image !== null)
        data_track.image_format = this.getImageFormat(data.product.image)
        data_track.has_price = (data.product.price > 0)
        data_track.price = data.product.price
        data_track.is_important = (data.product.important !== null && data.product.important)

        if(data.product.description !== null && data.product.description !== undefined){
            data_track.description_number_letters = data.product.description.length
        }
        data_track.position_relative = data.product.position_relative
        data_track.position_absolute = data.product.position_absolute
        data_track.is_promo = data.product.is_promo

        if (data.product.topsortWinner && data.product.topsortWinner.id) {
            data_track.master_product_id = data.product.topsortWinner.id;
            data_track.event = `${data_track.event}.topsort`
        }
        if(data.product.slotId){
            data_track.view_vue = `${data_track.view_vue}.${data.product.slotId}`
        }
        return data_track
    },
    trakingData(data) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `${process.env.VUE_APP_API_CLUVIMKT}/api/acquisitions.json`,
          data: data
        }).then(
          response => {
            resolve(response.data)
          },
          error => {
            reject(error);
          })
      })
    },
    storeAcquisitionData(parameters,session,customer_id) {
      let trakingData = {};
      let self = this;
      const urlParams = new URLSearchParams(parameters);
      trakingData.campaign_id = urlParams.get("campaign_id");
      trakingData.utm_medium = urlParams.get("utm_medium");
      trakingData.utm_campaign = urlParams.get("utm_campaign");
      trakingData.utm_term = urlParams.get("utm_term");
      trakingData.utm_content = urlParams.get("utm_content");
      trakingData.gclid = urlParams.get("gclid");
      trakingData.fbclid = urlParams.get("fbclid");
      trakingData.session_id = session;
      trakingData.customer_id = customer_id;
      trakingData.userAgent = navigator.userAgent;
      trakingData.referer = document.referrer;
      if (store.state.shared.acquisitionId === null || (trakingData.utm_medium || trakingData.utm_campaign || trakingData.campaign_id)) {
        self.trakingData(trakingData).then(resp => {
            store.commit("shared/SetAcquisitionId", resp.id, {root: true});
        });
      }
    },

    storeVuePerformance(){

        let resources = performance.getEntriesByType('resource');
        let totalSize = 0;
        resources.forEach(function (resource) {
            totalSize += resource.transferSize;
        });

        let data = {}
        data.transfer_data = Math.round(totalSize/1024)
        data.session_id = store.getters['profile/session_id']
        data.customer_id = store.getters['customer/instance_id']
        data.acquisition_id = store.getters['shared/acquisition_id']

        axios({
            method: "post",
            url: `${process.env.VUE_APP_API_CLUVIMKT}/api/performance_metrics.json`,
            data: {vue_performance_metric: data}
          })

    }
}

export {
    track
}
